import { render, staticRenderFns } from "./JournalPublistDetails.vue?vue&type=template&id=252ca508&"
import script from "./JournalPublistDetails.vue?vue&type=script&lang=js&"
export * from "./JournalPublistDetails.vue?vue&type=script&lang=js&"
import style0 from "./JournalPublistDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports